<template>
  <div :style="{ background: '#FFFFFF', height: '100vh' }">
    <onboarding-top-bar></onboarding-top-bar>
    <div class="content">
      <div class="choose-package">
        <div class="welcome">Start your Arnergy Journey!</div>
        <div class="subtext">
          Join the thousands of Arnergy users all over Africa who are enjoying
          unlimited answers with our solar solution today.
        </div>

        <div class="choice-type">Choose a payment type</div>
        <div class="boxes">
          <div v-for="item in paymentTypes" :key="item.id">
            <onboarding-select-button
              :title="item.title"
              :description="item.description"
              :isActive="activePaymentType && activePaymentType.id == item.id"
              @setActive="updateActivePaymentType(item)"
            />
          </div>
        </div>

        <div class="subtext">
          {{
            this.activePaymentType.key === "OS"
              ? this.paymentTypes[1].description
              : this.paymentTypes[0].description
          }}
        </div>

        <div class="package">
          <div v-for="item in packages" :key="item.id">
            <onboarding-select-button
              :ID="item.id"
              :title="item.name"
              :description="item.productDescription"
              :isActive="activePackageType && activePackageType.id == item.id"
              @setActive="updateActivePackageType(item)"
            />
          </div>
        </div>
      </div>

      <div class="right-image">
        <div class="description">
          {{
            this.activePackageType.productDescription
              ? this.activePackageType.productDescription
              : "Welcome!"
          }}
        </div>
        <img
          :src="require('../../../assets/img/polygon.svg')"
          class="polygon"
        />

        <img
          :src="require('../../../assets/img/man-woman.png')"
          class="man-woman"
        />
        <onboarding-button
          class="continue"
          type="next"
          text="Continue"
          @onButtonClick="handleContinue"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import ButtonOnboardingPackage from "../kitchen/ButtonOnboardingPackage";
import OnboardingSelectButton from "../kitchen/OnboardingSelectButton";
import SideIndicator from "../kitchen/Onboarding/SideIndicator.vue";
import ModalCalculate from "../kitchen/Onboarding/ModalCalculate";
import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
import MoneyFormat from "vue-money-format";

import OnboardingTopBar from "../../OnboardingTopBar.vue";
import OnboardingButton from "../../OnboardingButton.vue";

export default {
  name: "Onboarding",
  computed: {
    ...mapGetters(["getUserSession"])
  },
  components: {
    ButtonOnboardingPackage,
    OnboardingSelectButton,
    SideIndicator,
    ModalCalculate,
    ModalMain,
    MoneyFormat,
    OnboardingTopBar,
    OnboardingButton
  },
  data() {
    return {
      activeIndex: 0,
      showLoading: false,
      activePackageType: {},
      activePaymentType: {},
      packages: [
        {
          id: 1,
          name: "Arnergy IPP",
          productDescription:
            "A customized solution for residents in estates with centralized power generation",
          amountOS: 120,
          monthlyAmountLO: 10,
          tenure: 12
        }
      ],
      tempPackages: [
        {
          id: 1,
          name: "Arnergy IPP",
          productDescription:
            "A customized solution for residents in estates with centralized power generation",
          amountOS: 120,
          monthlyAmountLO: 10,
          tenure: 12
        }
      ],
      paymentTypes: [
        {
          id: 0,
          key: "LO",
          title: "Lease to Own (LO)",
          description:
            "This allows you to pay monthly over a specified lease tenor and own the system afterward"
        }
        // {
        //   id: 1,
        //   key: "OS",
        //   title: "Outright Sale (OS)",
        //   description:
        //     "This allows you to pay once and the package becomes yours forever"
        // }
      ]
    };
  },
  methods: {
    async fetchProducts() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let res = await HTTP.get("/product/products");

      // parse for "arnergy-select" use
      return res.data
        .map(item => {
          return {
            id: item.id,
            name: item.producttype,
            productDescription: item.productdescription,
            amountOS: item.amountos,
            monthlyAmountLO: item.monthlyamountlo,
            tenure: item.tenurelo
          };
        })
        .sort((a, b) => {
          return a.name > b.name ? 1 : -1;
        });
    },
    getOnboardingState(id) {
      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.get(`/onboardingstate/state`)
        .then(response => {
          this.$store.commit("saveOnboardingCustomerState", response.data);
        })
        .catch(error => console.log({ error }));
    },
    updateOnboardingState() {
      const HTTP = this.$httpUtils.FASTHTTP;

      console.log("tenure", this.activePackageType);

      const payloadData = {
        stateid: 0,
        packageType: this.$store.state.onboardingCustomerState.packageType,
        productType: this.activePackageType.name
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData)
        .then(res => {
          this.$store.commit("saveOnboardingCustomerState", res.data);
          console.log("rfsf", this.$store.state.onboardingCustomerState);
        })
        .catch(error => console.log({ error }));
    },
    updateActivePaymentType(item) {
      this.activePaymentType = item;
      if (this.activePaymentType.key === "OS") {
        this.packages = this.tempPackages.filter(
          x => x.name !== "Arnergy 10000"
        );
      } else this.packages = this.tempPackages;
    },
    updateActivePackageType(item) {
      this.activePackageType = item;
      localStorage.productId = this.activePackageType.id;
    },
    handleContinue() {
      if (!this.activePaymentType.key || !this.activePackageType.id) {
        alert("Please select Payment type and Package Type");
        return;
      }
      // save onboarding package type
      this.$store.commit("saveOnboardingPackageType", this.activePackageType);
      this.updateOnboardingRoute();
    },

    updateOnboardingRoute() {
      const HTTP = this.$httpUtils.FASTHTTP;
      this.showLoading = true;

      const payloadData = {
        stateid: 0,
        packageType: this.activePaymentType.key,
        productType: this.activePackageType.name
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData)
        .then(res => {
          this.showLoading = false;

          if (this.activePaymentType.key == "LO") {
            this.$router.push({ path: "/onboarding/lo/summary" });
          } else if (this.activePaymentType.key == "OS") {
            this.$router.push({ path: "/onboarding/os/agreement" });
          }
        })
        .catch(error => {
          this.showLoading = false;
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    }
  },
  async mounted() {
    // this.packages = await this.fetchProducts();
    // this.tempPackages = this.packages;
    this.updateOnboardingState();
    this.getOnboardingState(this.getUserSession.id);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_reduced_variables.scss";

.content {
  display: flex;
  width: 100%;
  padding: 0rem 14rem;
  font-family: "DM Sans";
  background: #ffffff;
}

.choose-package {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
}

.welcome {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.subtext {
  font-family: "DM Sans";
  width: 58.1rem;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  margin-bottom: 2.7rem;
}

.choice-type {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 2.7rem;
  color: #fe7a11;
}

.boxes {
  display: flex;
  margin-bottom: 2.7rem;
}

.package {
  display: flex;
  margin-bottom: 2.7rem;
}

.right-image {
  display: flex;
  flex-direction: column;
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.man-woman {
  margin-bottom: 9rem;
}

.continue {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/index.vue